<template>
  <main class="mr-sushi-page">
    <section class="bio-card">
      <div class="cover"><img src="@/assets/images/mr-sushi/cover.jpg" alt="" /></div>
      <div class="profile-picture"><img src="@/assets/images/mr-sushi/profile.jpg" alt="Mr Sushi" /></div>
      <h1>Mr Sushi</h1>
      <p class="tagline">&#x1F363; Sushi Lovers Happy Place &#x1F363;</p>
      <div class="links">
        <a class="bio-link primary" :href="menuHref" :target="isSpecialQrEntry ? '_self' : '_blank'" rel="noopener noreferrer">
          <img :src="images.menu" alt="Menu" /><span>Menu</span>
        </a>
        <p class="section-title">Rejoignez notre programme de fid&eacute;lit&eacute; et b&eacute;n&eacute;ficiez d&rsquo;offres exclusives &#x1F381;</p>
        <a class="bio-link" href="https://mrsushiclub.tn" target="_blank" rel="noopener noreferrer">
          <img :src="images.club" alt="Mr Sushi Club" /><span>Mr Sushi Club</span>
        </a>
        <p class="section-title">Rejoignez-nous sur les r&eacute;seaux sociaux !</p>
        <a v-for="social in socials" :key="social.label" class="bio-link" :href="social.href" target="_blank" rel="noopener noreferrer">
          <img :src="social.image" :alt="social.label" /><span>{{ social.label }}</span>
        </a>
      </div>
      <div class="contact-links">
        <a href="mailto:Mr.sushi.tn@gmail.com" aria-label="Envoyer un e-mail">
          <svg viewBox="0 0 24 24"><path d="M3 6h18v12H3zM3 7l9 7 9-7" /></svg>
        </a>
        <a href="tel:+21694255907" aria-label="Appeler Mr Sushi">
          <svg viewBox="0 0 24 24"><path d="M7 3H4a1 1 0 0 0-1 1c0 9.4 7.6 17 17 17a1 1 0 0 0 1-1v-3l-5-2-1.5 2.2a15 15 0 0 1-7.7-7.7L9 8z" /></svg>
        </a>
      </div>
    </section>
    <!-- Partage masque a la demande du client - a reactiver si besoin
    <transition name="fade">
      <div v-if="shareOpen" class="modal-backdrop" @click.self="shareOpen = false">
        <section class="share-modal" role="dialog" aria-modal="true" aria-labelledby="share-title">
          <header>
            <h2 id="share-title">Partager le lien bio</h2>
            <button type="button" aria-label="Fermer" @click="shareOpen = false">&times;</button>
          </header>
          <div class="share-content">
            <a v-for="item in shareLinks" :key="item.label" :href="item.href" target="_blank" rel="noopener noreferrer">
              <span>{{ item.icon }} &nbsp; {{ item.label }}</span><b>&rarr;</b>
            </a>
            <div class="copy-row">
              <input ref="shareInput" :value="pageUrl" readonly aria-label="Lien à partager" />
              <button type="button" @click="copyLink">{{ copied ? "Copie !" : "Copier" }}</button>
            </div>
          </div>
        </section>
      </div>
    </transition>
    -->
  </main>
</template>

<script>
import menu from "@/assets/images/mr-sushi/menu.png";
import club from "@/assets/images/mr-sushi/club.png";
import facebook from "@/assets/images/mr-sushi/facebook.png";
import instagram from "@/assets/images/mr-sushi/instagram.png";
// Conserves pour une reactivation eventuelle de Tripadvisor / Google Review
// import tripadvisor from "@/assets/images/mr-sushi/tripadvisor.png";
// import googleReview from "@/assets/images/mr-sushi/google-review.png";

export default {
  name: "MrSushi",
  page: { title: "Mr Sushi" },
  data() {
    // Partage masque a la demande du client - a reactiver si besoin
    // const pageUrl = "https://linko.tn/mrshushi";
    return {
      // pageUrl,
      // shareOpen: false,
      // copied: false,
      images: { menu, club },
      socials: [
        { label: "Facebook", href: "https://www.facebook.com/share/1C6rBUjn4P/", image: facebook },
        { label: "Instagram", href: "https://www.instagram.com/mrsushienoodles?igsh=MWY1NGw5eTl1djhybw==", image: instagram },
        // Masques a la demande du client - a reactiver si besoin
        // { label: "Tripadvisor", href: "https://www.tripadvisor.fr/Restaurant_Review-g295401-d27702447-Reviews-Mr_Sushi-Sousse_Sousse_Governorate.html", image: tripadvisor },
        // { label: "Google Review", href: "https://reviewthis.biz/hidden-sun-1752", image: googleReview }
      ]
      // shareLinks: [
      //   { label: "Partager sur Twitter", icon: "X", href: `https://twitter.com/share?url=${encodeURIComponent(pageUrl)}&text=Mr%20Sushi` },
      //   { label: "Partager sur Facebook", icon: "f", href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(pageUrl)}` },
      //   { label: "Partager sur Whatsapp", icon: "W", href: `https://api.whatsapp.com/send?text=${encodeURIComponent(pageUrl)}` }
      // ]
    };
  },
  computed: {
    isSpecialQrEntry() {
      return this.$route.params.code === "39ebe477-5090-4627-b8b0-193687fe383f";
    },
    menuHref() {
      return this.$router.resolve({
        path: `/qrmenu/${this.$route.params.code}`,
        query: { ...this.$route.query, menu: "1" }
      }).href;
    }
  }
  // Partage masque a la demande du client - a reactiver si besoin
  // methods: {
  //   async copyLink() {
  //     try {
  //       await navigator.clipboard.writeText(this.pageUrl);
  //     } catch (error) {
  //       this.$refs.shareInput.select();
  //       document.execCommand("copy");
  //     }
  //     this.copied = true;
  //     setTimeout(() => { this.copied = false; }, 1600);
  //   }
  // }
};
</script>

<style scoped>
.mr-sushi-page {
  --ink: #17212e;
  --ink-soft: #6b7688;
  --brand: #e8703a;
  --line: rgba(23,33,46,.09);
  --surface: #fff;
  min-height: 100vh; padding: 40px 18px; display: flex; justify-content: center; align-items: center;
  color: var(--ink); font-family: "Poppins", "Gilroy", system-ui, -apple-system, "Segoe UI", sans-serif;
  -webkit-font-smoothing: antialiased;
  background: #f4eff0;
  background-image:
    radial-gradient(58% 46% at 12% 8%, rgba(232,112,58,.22), transparent 62%),
    radial-gradient(52% 44% at 88% 4%, rgba(240,150,180,.26), transparent 60%),
    radial-gradient(64% 52% at 50% 104%, rgba(90,136,139,.22), transparent 62%),
    linear-gradient(160deg, #fdf6f1, #eef1f2);
  background-size: 160% 160%, 160% 160%, 160% 160%, 100% 100%;
  animation: gradient 22s ease-in-out infinite;
}
.bio-card {
  position: relative; width: 100%; max-width: 420px; min-width: 320px; padding: 0 22px 44px; overflow: hidden;
  text-align: center; background: var(--surface); border: 1px solid rgba(255,255,255,.7); border-radius: 28px;
  box-shadow: 0 1px 2px rgba(23,33,46,.05), 0 12px 28px -12px rgba(23,33,46,.16), 0 40px 80px -32px rgba(23,33,46,.28);
}
.cover { position: absolute; inset: 0 0 auto; height: 190px; overflow: hidden; }
.cover img { width: 100%; height: 100%; object-fit: cover; transform: scale(1.02); }
.cover::after {
  content: ""; position: absolute; inset: 0;
  background: linear-gradient(180deg, rgba(23,33,46,.12) 0%, rgba(23,33,46,0) 38%, rgba(255,255,255,.55) 76%, var(--surface) 100%);
}
.contact-links svg { width: 100%; fill: none; stroke: currentColor; stroke-width: 1.8; stroke-linecap: round; stroke-linejoin: round; }
.profile-picture {
  position: relative; z-index: 1; width: 116px; height: 116px; margin: 118px auto 0; padding: 5px;
  background: var(--surface); border-radius: 50%; box-shadow: 0 10px 26px -10px rgba(23,33,46,.45);
}
.profile-picture img { width: 100%; height: 100%; object-fit: cover; border-radius: 50%; }
h1 { position: relative; margin: 18px 0 0; color: #000; font-size: 25px; font-weight: 700; letter-spacing: -.02em; }
.tagline { margin: 8px 0 0; color: #585858; font-size: 15px; font-weight: 400; line-height: 1.6; }
.links { margin-top: 26px; }
.bio-link {
  position: relative; min-height: 62px; margin: 12px 0; padding: 10px 56px; display: flex; justify-content: center; align-items: center;
  color: var(--ink); font-size: 15px; font-weight: 600; letter-spacing: .01em; text-decoration: none;
  background: var(--surface); border: 1px solid var(--line); border-radius: 18px;
  box-shadow: 0 1px 2px rgba(23,33,46,.04), 0 8px 18px -12px rgba(23,33,46,.35);
  transition: transform .18s ease, box-shadow .18s ease, border-color .18s ease;
}
.bio-link:hover, .bio-link:focus-visible {
  color: var(--ink); transform: translateY(-2px); border-color: rgba(23,33,46,.16);
  box-shadow: 0 1px 2px rgba(23,33,46,.04), 0 16px 30px -14px rgba(23,33,46,.45);
}
.bio-link:active { transform: translateY(0); }
.bio-link img { position: absolute; left: 9px; width: 44px; height: 44px; object-fit: cover; border-radius: 14px; }
.bio-link.primary {
  color: #fff; background: linear-gradient(135deg, #f0854c, var(--brand));
  border-color: transparent; box-shadow: 0 10px 24px -10px rgba(232,112,58,.75);
}
.bio-link.primary:hover, .bio-link.primary:focus-visible { color: #fff; box-shadow: 0 18px 34px -12px rgba(232,112,58,.8); }
.bio-link.primary img { background: #fff; }
.section-title { margin: 30px 0 14px; color: var(--ink); font-size: 14px; font-weight: 600; line-height: 1.55; }
.contact-links { margin-top: 30px; display: flex; justify-content: center; gap: 12px; }
.contact-links a {
  width: 46px; height: 46px; padding: 12px; display: grid; place-items: center; color: var(--ink);
  border: 1px solid var(--line); border-radius: 14px; transition: transform .18s ease, background .18s ease;
}
.contact-links a:hover { background: #f6f7f9; transform: translateY(-2px); }
/* Partage masque a la demande du client - a reactiver si besoin
.share-button {
  position: absolute; z-index: 2; top: 16px; left: 16px; width: 38px; height: 38px; display: grid; place-items: center;
  padding: 9px; color: var(--ink); background: rgba(255,255,255,.9); backdrop-filter: blur(8px); border: 0; border-radius: 50%;
  box-shadow: 0 4px 14px rgba(23,33,46,.18); cursor: pointer;
}
.share-button svg { width: 100%; fill: none; stroke: currentColor; stroke-width: 1.8; stroke-linecap: round; stroke-linejoin: round; }
.modal-backdrop { position: fixed; z-index: 10000; inset: 0; padding: 16px; display: grid; place-items: center; background: rgba(23,33,46,.5); backdrop-filter: blur(4px); }
.share-modal { width: 100%; max-width: 460px; overflow: hidden; text-align: left; background: var(--surface); border-radius: 22px; box-shadow: 0 30px 70px -20px rgba(23,33,46,.45); }
.share-modal header { padding: 18px 20px; display: flex; align-items: center; border-bottom: 1px solid var(--line); }
.share-modal h2 { flex: 1; margin: 0; text-align: center; font-size: 16px; font-weight: 600; }
.share-modal header button { color: var(--ink-soft); border: 0; background: transparent; font-size: 26px; line-height: 1; cursor: pointer; }
.share-content { padding: 18px; }
.share-content > a { padding: 13px 12px; display: flex; justify-content: space-between; color: var(--ink); font-size: 14px; font-weight: 500; text-decoration: none; border-radius: 12px; transition: background .15s ease; }
.share-content > a:hover { background: #f6f7f9; }
.copy-row { margin-top: 18px; display: flex; gap: 8px; }
.copy-row input { min-width: 0; flex: 1; padding: 13px 14px; color: var(--ink-soft); font-size: 14px; background: #f6f7f9; border: 1px solid var(--line); border-radius: 12px; }
.copy-row input:focus { outline: 2px solid rgba(232,112,58,.35); outline-offset: 1px; }
.copy-row button { width: 104px; color: #fff; font-family: inherit; font-size: 14px; font-weight: 600; background: var(--brand); border: 0; border-radius: 12px; cursor: pointer; transition: filter .15s ease; }
.copy-row button:hover { filter: brightness(1.06); }
.fade-enter-active, .fade-leave-active { transition: opacity .2s; }
.fade-enter, .fade-leave-to { opacity: 0; }
*/
@keyframes gradient {
  0%, 100% { background-position: 0 0, 100% 0, 50% 100%, 0 0; }
  50% { background-position: 30% 20%, 70% 15%, 50% 80%, 0 0; }
}
@media (max-width: 576px) {
  .mr-sushi-page { padding: 0; align-items: stretch; }
  .bio-card { max-width: none; min-height: 100vh; border: 0; border-radius: 0; box-shadow: none; }
}
@media (prefers-reduced-motion: reduce) {
  .mr-sushi-page { animation: none; }
  .bio-link, .contact-links a { transition: none; }
  .bio-link:hover, .contact-links a:hover { transform: none; }
}
</style>
